<template>
  <Formulario />
</template>

<script>
import Formulario from "@/components/Formulario";

export default {
  name: "App",
  components: {Formulario},
  data() {
    return {
      instances: []
    };
  },
  async mounted() {
  },
  methods: {

  },
};
</script>

<style>
.bogus {
  border: 4px solid black;
}
</style>
